<template>
	<!-- <v-container v-if="success" class="text-xs-center">
		<p class="body-1 font-weight-bold">
			Vielen Dank für Ihre Kontaktaufnahme. Wie werden uns umgehend bei Ihnen
			melden.
		</p>
		<v-btn id="btn-contact" to="/finished" color="primary"
			>Weiter zum Abfindungsrechner</v-btn
		>
	</v-container> -->
	<v-container v-if="isSending" class="text-xs-center">
		<v-progress-circular
			:size="70"
			:width="7"
			color="primary"
			indeterminate
		></v-progress-circular>
	</v-container>
	<v-form v-else v-model="valid" ref="form" lazy-validation>
		<p v-if="error" class="body-1 red--text">
			Bei der Verarbeitung Ihrer Daten ist leider eine Fehler aufgetreten. Bitte
			versuchen sie es später noch einmal.
		</p>
		<v-text-field
			label="Name, Vorname"
			v-model="params.name"
			:rules="nameRules"
			required
		>
		</v-text-field>
		<v-text-field
			label="E-Mail-Adresse"
			v-model="params.email"
			:rules="emailRules"
			required
		></v-text-field>
		<v-text-field
			label="Telefon"
			v-model="params.phone"
			:rules="phoneRules"
			required
		></v-text-field>
		<v-text-field label="Anmerkungen" v-model="params.message"></v-text-field>
		<v-checkbox
			v-model="params.privacy"
			required
			class="privacy"
			:rules="privacyRules"
		>
			<template v-slot:label>
				<div>
					<p class="body-1">
						Ich stimme zu, dass meine Angaben aus dem Kontaktformular zur
						Beantwortung meiner Anfrage erhoben und verarbeitet werden. Die
						Daten werden nach abgeschlossener Bearbeitung Ihrer Anfrage
						gelöscht.
						<br /><br />
						<strong>Hinweis</strong>: Sie können Ihre Einwilligung jederzeit für
						die Zukunft per E-Mail an
						<a :href="`mailto:${privacyEmail}`">{{ privacyEmail }}</a>
						widerrufen.
					</p>
					<p class="body-1">
						<strong>Hinweis</strong>: Diese Überprüfung ersetzt keine
						Rechtsberatung für den konkreten Sachverhalt im Einzelfall, sondern
						gibt lediglich eine erste Einschätzung anhand allgemeiner
						Prüfungskriterien. Eine Haftung für das Prüfungsergebnis im Rahmen
						des kostenlosen Kündigungs-Checks wird unsererseits nicht
						übernommen.
					</p>
					<p class="body-1">
						Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in
						unserer
						<a :href="privacyStatement" target="_blank">Datenschutzerklärung </a
						>.
					</p>
				</div>
			</template>
		</v-checkbox>
		<v-container
			><v-layout justify-space-between>
				<v-btn
					id="btn-contact"
					@click="submit"
					color="primary"
					class="btn-ovr"
					v-on:load="sendMessage"
					><span style="white-space: normal;"
						>Anfragen und Abfindungshöhe berechnen</span
					>
				</v-btn>
				<router-link to="/finished_noform" class="cntr"
					>WEITER OHNE DATENEINGABE</router-link
				>
			</v-layout></v-container
		>
	</v-form>
</template>

<style>
.privacy .v-input__slot {
	align-items: start;
	justify-content: center;
	margin-bottom: 0;
}

.privacy .v-messages {
	margin-bottom: 1.3em;
}

.cntr {
	-webkit-transform: translateY(25%);
	transform: translateY(25%);
}

@media all and (max-width: 500px) {
	.btn-ovr {
		height: 100px;
		display: block;
	}

	.layout {
		display: block;
	}

	.cntr {
		margin-left: 0.5rem;
	}
}
</style>

<script>
import { mapState } from 'vuex';
// import VueRecaptcha from 'vue-recaptcha';

const params = new URLSearchParams(window.location.search);

export default {
	computed: {
		...mapState({
			isSending: 'isSending',
			success: 'sendSuccess',
			error: 'sendError',
		}),
	},
	// components: {
	// 	VueRecaptcha,
	// },
	methods: {
		submit() {
			const isValid = this.$refs.form.validate();

			if (isValid) {
				this.$store.dispatch('sendMail', {
					...this.params,
				});
				this.$router.push('/finished_form');
			} else {
				this.sendMessage();
			}
		},
		sendMessage() {
			window.parent.postMessage(
				{
					event: 'resize',
					height: Math.max(
						document.body.offsetHeight,
						document.documentElement.offsetHeight
					),
				},
				'*'
			);
		},
		// onVerify(res) {
		// 	this.captcha.token = res;
		// },
		// onExpired() {
		// 	this.captcha.token = '';
		// },
	},
	updated() {
		let self = this;
		window.setTimeout(function () {
			self.sendMessage();
		}, 200);
	},
	created() {
		this.$store.dispatch('resetResult');
	},
	data: () => ({
		valid: false,
		params: {
			name: '',
			phone: '',
			email: '',
			message: '',
			privacy: '',
		},
		nameRules: [v => !!v || 'Bitte geben Sie Ihren Namem an'],
		emailRules: [
			v => !!v || 'Bitte geben Sie eine Email-Adresse an',
			v => /.+@.+/.test(v) || 'Bitte geben Sie eine gültige Email-Adresse an',
		],
		phoneRules: [
			v => !!v || 'Bitte geben Sie eine Telefonnummer an',
			// v => /^[0-9,+,-,()]*$/.test(v) || 'Bitte geben Sie eine gültige Telefonnummer an',
		],
		privacyRules: [v => !!v || 'Sie müssen zustimmen, um fortzufahren'],
		// captcha: {
		// 	key: window.env.GCAPTCHA_KEY,
		// 	token: '',
		// },
		privacyStatement: params.get('privacy_url') || '/privacy',
		privacyEmail:
			params.get('privacy_email') ||
			params.get('email') ||
			'abfindungsrechner@kanzlei-hasselbach.de',
	}),
};
</script>
